export default "__VITE_ASSET__7e35056a__"